import { CardProps } from 'parkdepot-shared/components/Card'
import Icon from '@components/style/Icon.style'
import primitives from 'parkdepot-shared/theme/primitives'
import { styled } from 'parkdepot-shared/theme'

export const CardOverrides: CardProps['styleOverrides'] = ({ $theme }) => ({
    padding: `${$theme.sizing.scale700} ${$theme.sizing.scale1000}`,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: $theme.sizing.scale700,
    // for icon size
    fontSize: $theme.sizing.scale700
})

export const PositiveIconStyle: Parameters<typeof Icon>['0']['$style'] = {
    fontSize: '20px',
    color: primitives.positive700
}

export const NegativeIconStyle: Parameters<typeof Icon>['0']['$style'] = {
    fontSize: '20px',
    color: primitives.red700
}

export const Title = styled<'h1', { $error: boolean }>('h1', ({ $theme, $error }) => ({
    ...$theme.typography.HeadingSmall,
    color: $error ? primitives.red700 : primitives.positive700,
    margin: 0,
    textAlign: 'center'
}))

export const Description = styled('p', ({ $theme }) => ({
    ...$theme.typography.ParagraphMedium,
    margin: 0,
    textAlign: 'center'
}))
